import {
  AfterViewInit,
  Directive,
  ElementRef,
  OnDestroy,
  Renderer2,
} from '@angular/core';

@Directive({
  selector: '[searchBarClearIconFirefox]',
})
export class SearchBarClearIconFirefoxDirective
  implements AfterViewInit, OnDestroy
{
  private clearButton?: HTMLElement;
  private inputElement?: HTMLInputElement;
  private isFirefox = navigator.userAgent.toLowerCase().includes('firefox');
  private listeners: (() => void)[] = [];

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngAfterViewInit(): void {
    if (!this.isFirefox) return;

    const shadowRoot = (this.el.nativeElement.querySelector('goa-input')
      .shadowRoot ||
      this.el.nativeElement.querySelector('*')
        ?.shadowRoot) as ShadowRoot | null;
    if (!shadowRoot) return;

    setTimeout(() => {
      this.inputElement = shadowRoot.querySelector(
        'div > div > input'
      ) as HTMLInputElement;

      if (!this.inputElement) return;

      this.inputElement.style.width = '100%';
      this.inputElement.style.paddingRight = '35px';

      this.clearButton = this.renderer.createElement('button');
      this.renderer.setStyle(this.clearButton, 'position', 'absolute');
      this.renderer.setStyle(this.clearButton, 'right', '8px');
      this.renderer.setStyle(this.clearButton, 'top', '45%');
      this.renderer.setStyle(this.clearButton, 'transform', 'translateY(-50%)');
      this.renderer.setStyle(this.clearButton, 'background', 'transparent');
      this.renderer.setStyle(this.clearButton, 'border', 'none');
      this.renderer.setStyle(this.clearButton, 'cursor', 'pointer');
      this.renderer.setStyle(this.clearButton, 'font-size', '18px');
      this.renderer.setStyle(this.clearButton, 'color', '#666');
      this.renderer.setStyle(this.clearButton, 'opacity', '0');
      this.renderer.setStyle(this.clearButton, 'transition', 'opacity 0.2s');

      if (!this.clearButton) return;

      this.clearButton.innerHTML = '&times;'; // simple X mark

      // Wrap input in relative container if needed
      const wrapper = this.renderer.createElement('div');
      this.renderer.setStyle(wrapper, 'position', 'relative');
      this.renderer.setStyle(wrapper, 'display', 'inline-block');
      this.renderer.setStyle(wrapper, 'width', '100%');

      const parent = this.inputElement.parentElement;
      if (parent) {
        this.renderer.insertBefore(parent, wrapper, this.inputElement);
        this.renderer.appendChild(wrapper, this.inputElement);
        this.renderer.appendChild(wrapper, this.clearButton);
      }

      // Show/hide logic
      const updateVisibility = () => {
        const visible = !!this.inputElement?.value;
        this.renderer.setStyle(
          this.clearButton,
          'opacity',
          visible ? '1' : '0'
        );
        this.renderer.setStyle(
          this.clearButton,
          'pointer-events',
          visible ? 'auto' : 'none'
        );
      };

      this.listeners.push(
        this.renderer.listen(this.inputElement, 'input', updateVisibility),
        this.renderer.listen(this.clearButton, 'mouseenter', () =>
          this.renderer.setStyle(this.clearButton, 'opacity', '1')
        ),
        this.renderer.listen(this.clearButton, 'mouseleave', updateVisibility),
        this.renderer.listen(this.clearButton, 'click', () => {
          if (!this.inputElement) return;
          this.inputElement.value = '';
          this.inputElement.dispatchEvent(
            new Event('input', { bubbles: true })
          );
          updateVisibility();
        })
      );

      updateVisibility();
    });
  }

  ngOnDestroy() {
    this.listeners.forEach((unsub) => unsub());
  }
}
